import dayjs from 'dayjs'

import { Dot } from '../../components/PeriodTable/mocks'
import { ClassifiedReplacementBlock } from '../../rest/types/Classified'

export function BlockReplacementTransformer({
  block,
  t,
}: {
  block: ClassifiedReplacementBlock
  t: any
}) {
  return {
    ...((block?.specialities?.length ||
      block?.secretariats?.length ||
      block?.cabinetType?.name) && {
      adsTypes: {
        texts: {
          seeLess: t('ads_types_see_less'),
          seeMore: t('ads_types_see_more'),
        },
        items: [
          ...(block?.secretariats?.length
            ? [
                {
                  title: t('ads_types_secretariat_type_title'),
                  texts: block?.secretariats.map((item) => item.name),
                },
              ]
            : []),
          ...(block?.cabinetType?.name
            ? [
                {
                  title: t('ads_types_cabinet_type_title'),
                  text: block?.cabinetType?.name,
                },
              ]
            : []),
          ...(block?.specialities?.length
            ? [
                {
                  title: t('ads_types_speciality_title'),
                  texts: block?.specialities.map((item) => item.name),
                },
              ]
            : []),
        ],
      },
    }),
    adsDetails: {
      items: [
        {
          label: t('ads_details_negociable_days_title'),
          value: block?.negociableDays
            ? t('form_boolean_value_true')
            : t('form_boolean_value_false'),
        },
        {
          label: t('ads_details_guard_title'),
          value: block?.guard
            ? t('form_boolean_value_true')
            : t('form_boolean_value_false'),
        },
        ...(block?.sector
          ? [
              {
                label: t('ads_details_sector_title'),
                value:
                  block?.sector === 'first'
                    ? t('ads_details_sector_first_value')
                    : block?.sector === 'second'
                    ? t('ads_details_sector_second_value')
                    : block?.sector === 'third'
                    ? t('ads_details_sector_third_value')
                    : '',
              },
            ]
          : []),
        ...(block?.rate
          ? [
              {
                label: t('ads_details_rate_title'),
                value: `${block?.rate}${t('ads_details_rate_percentage')}`,
              },
            ]
          : []),
        {
          label: t('ads_details_collaboration_replacement_title'),
          value:
            (typeof block.collabReplacement === 'string' &&
              block.collabReplacement === 'true') ||
            (typeof block.collabReplacement === 'boolean' &&
              block.collabReplacement)
              ? t('form_boolean_value_true')
              : t('form_boolean_value_false'),
        },
        ...(block?.softwares
          ? [
              {
                label: t('ads_details_sofware_title'),
                value: block?.softwares,
              },
            ]
          : []),
      ],
    },

    adsReplacementDate: {
      title: t('ads_replacement_date_title'),
      ...(block?.startDate && {
        subtitle: {
          label: t('ads_replacement_date_replacement_subtitle'),
          requestedDate: dayjs(block?.startDate).format('DD MMMM YYYY'),
        },
      }),
      periods: {
        label: t('ads_replacement_date_period_label'),
        ...(block?.startDate && {
          start: dayjs(block?.startDate).format('DD MMMM YYYY'),
        }),
        ...(block?.endDate && {
          finish: dayjs(block?.endDate).format('DD MMMM YYYY'),
        }),
      },
      periodTable: {
        labels: {
          morningRowLabel: t('ads_replacement_date_morning_row_Label'),
          afternoonRowLabel: t('ads_replacement_date_afternoon_row_Label'),
          mondayLabel: t('ads_replacement_date_monday_label'),
          tuesdayLabel: t('ads_replacement_date_tuesday_label'),
          wednesdayLabel: t('ads_replacement_date_wednesday_label'),
          thursdayLabel: t('ads_replacement_date_thursday_label'),
          fridayLabel: t('ads_replacement_date_friday_label'),
          saturdayLabel: t('ads_replacement_date_saturday_label'),
          sundayLabel: t('ads_replacement_date_sunday_label'),
          columnLabel: t('ads_replacement_date_column_label'),
        },
        monday: {
          ...(block?.period?.mondayMorning && {
            morning: <Dot />,
          }),
          ...(block?.period?.mondayAfternoon && {
            afternoon: <Dot />,
          }),
        },
        tuesday: {
          ...(block?.period?.tuesdayMorning && {
            morning: <Dot />,
          }),
          ...(block?.period?.tuesdayAfternoon && {
            afternoon: <Dot />,
          }),
        },
        wednesday: {
          ...(block?.period?.wednesdayMorning && {
            morning: <Dot />,
          }),
          ...(block?.period?.wednesdayAfternoon && {
            afternoon: <Dot />,
          }),
        },
        thursday: {
          ...(block?.period?.thursdayMorning && {
            morning: <Dot />,
          }),
          ...(block?.period?.thursdayAfternoon && {
            afternoon: <Dot />,
          }),
        },
        friday: {
          ...(block?.period?.fridayMorning && {
            morning: <Dot />,
          }),
          ...(block?.period?.fridayAfternoon && {
            afternoon: <Dot />,
          }),
        },
        saturday: {
          ...(block?.period?.saturdayMorning && {
            morning: <Dot />,
          }),
          ...(block?.period?.saturdayAfternoon && {
            afternoon: <Dot />,
          }),
        },
        sunday: {
          ...(block?.period?.sundayMorning && {
            morning: <Dot />,
          }),
          ...(block?.period?.sundayAfternoon && {
            afternoon: <Dot />,
          }),
        },
        withGrid: true,
      },
    },
  }
}
